import { api } from '.';
import { Project } from '../types';

export async function getProjectDetails(id: string): Promise<Project> {
  const response = await api.get(`admin/projects/${id}`);
  return await response.json();
}
